import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BoldReportDesignerComponent } from './reportdesigner.component';
export class BoldReportDesignerModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [
        CommonModule
    ],
    declarations: [
        BoldReportDesignerComponent
    ],
    exports: [
        BoldReportDesignerComponent
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function BoldReportDesignerModule_tsickle_Closure_declarations() {
/** @type {?} */
BoldReportDesignerModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
BoldReportDesignerModule.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
